import { Node } from "../../Utils/Collections/Node";
import { NodeList } from "../../Utils/Collections/NodeList";
import { Pool } from "../../Utils/Collections/Pool";
import { TIMER } from "../Gameplay";
import { ScreenOverlay } from "./ScreenOverlay";



export interface IFlashFxSettings {
    /**
     * Barva efektu
     */
    color: pc.Color;
    /**
     * Cilova hodnota alfa kanalu
     */
    alpha: number;
    /**
     * Ease funkce pro dosazeni cilove alfy
     */
    easeIn: (k: number) => number;
    /**
     * Doba v ms pro dosazeni cilove alfy
     */
    lenIn: number;
    /**
     * Ease funkce pro navrat z cilove alfy do 0
     */
    easeOut: (k: number) => number;
    /**
     * Doba v ms pro navrat z cilove alfy do 0
     */
    lenOut: number;
    /**
     * Callback volany po dosazeni cilove alfy
     */
    onCompleteIn?: () => void;
    /**
     * Callback volany po dokonceni efektu
     */
    onCompleteOut?: () => void;
}



interface IFlashFxCurVals {
    color: pc.Color;
    alpha: number;
}



class FlashFx {
    private _settings: IFlashFxSettings;

    private _stateTime: number;
    private _state: number;
    private _curVals: IFlashFxCurVals;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        this._curVals = {
            color: new pc.Color(),
            alpha: 0
        };
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    start(settings: IFlashFxSettings): void {
        this._settings = settings;
        this._stateTime = TIMER.time;
        this._state = 0;

        this._curVals.color.copy(settings.color);
        this._curVals.alpha = 0;
    }

    //-------------------------------------------------------------------------
    /**
     * 
     * @returns Aktualni hodnoty efektu nebo undefined, pokud doslo k dokonceni efektu
     */
    //-------------------------------------------------------------------------
    update(): IFlashFxCurVals {
        let time = TIMER.time - this._stateTime;
        let progress: number;

        switch (this._state) {
            case 0: {
                progress = time / this._settings.lenIn;

                if (progress < 1) {
                    this._curVals.alpha = this._settings.easeIn(progress) * this._settings.alpha;
                    break;
                }

                time -= this._settings.lenIn;
                this._stateTime += this._settings.lenIn;
                this._state++;

                if (this._settings.onCompleteIn)
                    this._settings.onCompleteIn();
            }
            case 1: {
                let progress = time / this._settings.lenOut;

                if (progress < 1) {
                    this._curVals.alpha = this._settings.alpha - this._settings.easeOut(progress) * this._settings.alpha;
                }
                else {
                    this._curVals.alpha = 0;
                    this._state++;

                    if (this._settings.onCompleteOut)
                        this._settings.onCompleteOut();

                    return undefined;
                }

                break;
            }
        }

        return this._curVals;
    }
}



export class FlashFxManager {
    private _freeFx: Pool<FlashFx>;
    private _actFx: NodeList<FlashFx>;

    private _scrOverlay: ScreenOverlay;
    private _scrOverlayColor: pc.Color;
    private _scrOverlayAlpha: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(screen: pc.Entity) {
        this._scrOverlay = new ScreenOverlay(screen);
        this._scrOverlayColor = new pc.Color();

        this._freeFx = new Pool<FlashFx>(FlashFx, 1, true);
        this._actFx = new NodeList<FlashFx>();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        if (this._scrOverlay.enabled) {
            this._scrOverlay.enabled = false;

            this._actFx.forEach((fx: FlashFx): void => {
                this._freeFx.returnItem(fx);
            });
            this._actFx.clear();
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    startFx(settings: IFlashFxSettings): void {
        let fx = this._freeFx.getItem();

        fx.start(settings);
        this._actFx.add(fx);

        if (!this._scrOverlay.enabled)
            this._scrOverlay.enabled = true;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        if (this._actFx.empty)
            return;

        // Vypocitat barvu a alfu
        this._scrOverlayColor.set(0, 0, 0);
        this._scrOverlayAlpha = 0;

        this._actFx.forEach((fx: FlashFx, fxNode: Node<FlashFx>): void => {
            let fxVal = fx.update();

            if (fxVal) {
                if (fxVal.alpha > this._scrOverlayAlpha)
                    this._scrOverlayAlpha = fxVal.alpha;

                this._scrOverlayColor.lerp(this._scrOverlayColor, fxVal.color, fxVal.alpha / this._scrOverlayAlpha);
            }
            else {
                // Vyradit efekt ze seznamu aktivnich
                this._actFx.removeByNode(fxNode);
                this._freeFx.returnItem(fx);

                // Pokud neni zadny dalsi efekt, tak vypnout overlay
                if (this._actFx.empty)
                    this._scrOverlay.enabled = false;
            }
        });

        // Nastavit overlay
        this._scrOverlay.color = this._scrOverlayColor;
        this._scrOverlay.opacity = this._scrOverlayAlpha;
    }
}